export default __webpack_public_path__ + "media/components/Header/Images/Kerning_big-7640fbdd2182297fad0093e6c13d4955.svg";